/**
 * Newsletter popover logic: whent to show + hide
 */
var $ = require('jquery');
var cookieStorage = require('../cookie');
var formHandler = require('./form').handleNewsletterSubmit;
require('bootstrap/js/modal');

function launchModal() {
  cookieStorage.set('inertiaNewsletterPop', true, +new Date() + 302400000*2);
  $('.inertia-modal-newsletter').modal({
    backdrop: false
  });
  $('#inertiaNewsletterForm-modal').on('submit', formHandler);
}

function maybeLaunch() {
  if (!cookieStorage.get('inertiaNewsletterPop')) {
    return launchModal();
  }
}

module.exports = {
  maybeLaunch: maybeLaunch
};
